module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "start"
    }
  }, [_c('a', {
    attrs: {
      "id": "chap1"
    }
  }), _vm._v("CHAPTER ONE")]), _vm._v(" "), _c('p', {
    staticClass: "noind sgc-1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE FOOD LOOKED APPETIZING")]), _vm._v(" enough. It was the Styrofoam and the plastic wrap that spoiled the visual impact.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I opened the little package containing a knife, fork and spoon, a paper napkin, salt and pepper. It wasn’t easy to open—why do they make the plastic so strong? Pulling out the fork, I broke one of the tines—why do they make the plastic so weak? But I wasn’t here to make a critical survey of the plastics industry so I turned my attention back to the food.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The small salad wasn’t too bad. The tomato slices were surprisingly tasty and the lettuce was reasonably crisp—not an easy achievement when it has been tightly wrapped for hours. The mustard greens and the endives were acceptable and the tiny croutons were crunchy. The dressing was too thick and too sweet for my preference but there was no pleasing every salad eater among the tens of thousands of airline passengers being served this same meal.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There was sufficient vinegar in the dressing—despite its sweetness—that I waited to finish before pouring the red Bordeaux into the plastic cup. Plastic is a terrible surrounding for any wine, especially a wine which is already struggling vainly against the disadvantaged background of being without a vintage—the vinous equivalent of being illegitimate.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26cf24a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/4start.vue
// module id = 72
// module chunks = 0